import { Controller } from '@hotwired/stimulus';

import ajax from '@/modules/ajax';
import GridyCommon from '@/modules/gridy_common';
import I18n from '@/modules/i18n';
import ModuleLoader from '@/modules/module_loader';
import Templates from '@/pages/events/templates';

export default class extends Controller {
  connect() {
    this.options = ModuleLoader.getOptions();
    this.checkedinAllField = document.querySelector('[data-checkedin=""]');
    this.checkedinFalseField = document.querySelector('[data-checkedin="false"]');
    this.checkedinFields = document.querySelectorAll('[data-checkedin]');
    this.enrolledFields = document.querySelectorAll('[data-enrolled]');
    this.grid = $('[data-gridy]');

    // The checkin fields are re-rendered by gridy on every refresh, so we delegate from the
    // grid instead of rebinding each field after it redraws.
    this.grid[0].addEventListener('change', this.#onChange);

    this.#gridy();
    this.#bindFilters();
  }

  disconnect() {
    this.grid[0].removeEventListener('change', this.#onChange);
  }

  #bindFilters() {
    for (const field of this.enrolledFields) {
      field.addEventListener('change', () => {
        if (field.value === '') {
          this.checkedinFalseField.checked = true;
        } else {
          this.checkedinAllField.checked = true;
        }

        this.#refreshGrid();
      });
    }

    for (const field of this.checkedinFields) {
      field.addEventListener('change', () => this.#refreshGrid());
    }
  }

  #gridy() {
    GridyCommon.gridy(this.grid, {
      find: 'ticket_order_items.name',
      paramsElements: ['[data-checkedin]:checked', '[data-enrolled]:checked'],
      sortName: 'ticket_order_items.name',
      template: Templates.events.gridy_checkin,
      url: this.options.gridy.url,

      headers: [
        { name: I18n.t('id'), value: '' },
        { name: I18n.t('name'), value: 'ticket_order_items.name' },
        { name: I18n.t('activerecord.attributes.user.email'), value: 'ticket_order_items.email' },
        { name: I18n.t('activerecord.models.ticket.one'), value: 'tickets.name' },
        { name: I18n.t('activerecord.models.invoice.one'), value: '' },
        { name: I18n.t('activerecord.attributes.ticket_order_item.checkin'), value: '' },
        { name: I18n.t('action.other'), value: '' },
      ],
    });
  }

  #onChange = (event) => {
    const field = event.target.closest('[data-checkin]');

    if (!field) return;

    ajax({
      body: { c: field.checked },
      done: () => this.#refreshGrid(),
      method: 'PATCH',
      url: this.options.checkin_uri.replace(':id', field.dataset.checkin),
    });
  };

  #refreshGrid() {
    this.grid.gridy('refresh');
  }
}
